export default __webpack_public_path__ + "static/media/home-creative-portfolio-img-05.600bfae2.jpg";